const apiUrl = process.env.REACT_APP_API_URL;
export const PutUsuariIdPerfil = async (id : string, page : string, usuari: any ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/${id}/perfil`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(usuari)
        });
        return response.status;

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
